import { useClientsContext } from "contexts/ClientsContext";
import { useEffect, useState } from "react";
import getClientDisplayName from "utils/getClientDisplayName";
import searchClientsByName from "utils/searchClientsByName";
import styles from "./ClientSelect.module.scss";

interface ClientSelectProps {
  onSelect: (client: PatientChartResponseEntry) => void;
}

const ClientSelect = ({ onSelect }: ClientSelectProps) => {
  const {
    individuals,
    couples,
    // isLoadingClients,
    initializeClients,
  } = useClientsContext();

  const [query, setQuery] = useState("");

  const clients = [...individuals, ...couples];

  const clientsFiltered = searchClientsByName(clients, query)
    .sort((a, b) =>
      getClientDisplayName(a) < getClientDisplayName(b) ? -1 : 1,
    )
    ?.filter((client) => client.patient.client_status === "patient");

  useEffect(() => {
    initializeClients();
  }, [initializeClients]);

  return (
    <div className={styles["container"]}>
      <input
        className={styles["search-input"]}
        type="text"
        placeholder="Search"
        onChange={(event) => setQuery(event.currentTarget.value)}
        value={query}
      />
      <div className={styles["list-scroll-container"]}>
        <ul>
          {clientsFiltered.map((client) => {
            return (
              <li
                key={client.patient.orchid_user_id}
                onClick={() => onSelect(client)}
              >
                {getClientDisplayName(client)}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ClientSelect;
